var exports = {
  "E6": "ChannelEmbed.module__embed___akZ0ZW",
  "vO": "ChannelEmbed.module__embedFull___akZ0ZW",
  "UT": "ChannelEmbed.module__gridContainer___akZ0ZW",
  "Vg": "ChannelEmbed.module__grid___akZ0ZW",
  "$H": "ChannelEmbed.module__hasThumbnail___akZ0ZW",
  "zE": "ChannelEmbed.module__embedContent___akZ0ZW",
  "Cj": "ChannelEmbed.module__embedLink___akZ0ZW",
  "zC": "ChannelEmbed.module__embedProvider___akZ0ZW",
  "rN": "ChannelEmbed.module__embedAuthor___akZ0ZW",
  "QQ": "ChannelEmbed.module__embedAuthorName___akZ0ZW",
  "av": "ChannelEmbed.module__embedAuthorNameLink___akZ0ZW",
  "SG": "ChannelEmbed.module__embedAuthorIcon___akZ0ZW",
  "gt": "ChannelEmbed.module__embedTitle___akZ0ZW",
  "cD": "ChannelEmbed.module__embedDescription___akZ0ZW",
  "j0": "ChannelEmbed.module__embedFields___akZ0ZW",
  "Me": "ChannelEmbed.module__embedField___akZ0ZW",
  "$L": "ChannelEmbed.module__embedFieldName___akZ0ZW",
  "VN": "ChannelEmbed.module__embedFieldValue___akZ0ZW",
  "oy": "ChannelEmbed.module__embedFooterText___akZ0ZW",
  "W$": "ChannelEmbed.module__embedMedia___akZ0ZW",
  "ad": "ChannelEmbed.module__embedThumbnail___akZ0ZW",
  "te": "ChannelEmbed.module__embedFooter___akZ0ZW",
  "mG": "ChannelEmbed.module__embedFooterIcon___akZ0ZW",
  "i8": "ChannelEmbed.module__embedFooterSeparator___akZ0ZW",
  "PN": "ChannelEmbed.module__embedGifvContainer___akZ0ZW",
  "kL": "ChannelEmbed.module__container___akZ0ZW",
  "mQ": "ChannelEmbed.module__mediaFrame___akZ0ZW",
  "Mc": "ChannelEmbed.module__suppressButton___akZ0ZW",
  "wJ": "ChannelEmbed.module__mediaSuppressButton___akZ0ZW",
  "Fk": "ChannelEmbed.module__blueskyMediaEngagement___akZ0ZW",
  "Uf": "ChannelEmbed.module__blueskyGalleryMedia___akZ0ZW",
  "$j": "ChannelEmbed.module__blueskyEngagement___akZ0ZW",
  "Z": "ChannelEmbed.module__blueskyNestedEmbedContainer___akZ0ZW",
  "mx": "ChannelEmbed.module__blueskyNestedEmbed___akZ0ZW",
  "gp": "ChannelEmbed.module__blueskyNestedMediaEngagement___akZ0ZW",
  "qP": "ChannelEmbed.module__blueskyEngagementItem___akZ0ZW",
};

module.exports = exports;
